import { render, staticRenderFns } from "./couponGrantRecord.vue?vue&type=template&id=6c9532be&scoped=true"
import script from "./couponGrantRecord.vue?vue&type=script&lang=js"
export * from "./couponGrantRecord.vue?vue&type=script&lang=js"
import style0 from "./couponGrantRecord.vue?vue&type=style&index=0&id=6c9532be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9532be",
  null
  
)

export default component.exports